import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from 'react-bootstrap/InputGroup';
import { useSelector, useDispatch } from "react-redux";
import MasterList from "../../../common/MasterList";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import MachinesModal from "./MachinesForm";
import {
  fetchMasterList,
  addMasterRecord,
  deleteMasterRecord,
  searchMasterList,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { toastFunc } from "../../../../components/common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import { AlertModal } from "../../../common/AlertModal";
import { formatDateTime } from "../../../../common/Validations";
import ItemService from "../../../../services/commonService";

const Machines = () => {
  const [open, setOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [confirmModel, setConfirmModel] = useState(false);
  const [unassignConfirmModel, setUnassignConfirmModel] = useState(false);
  const [machineToUnassign, setMachineToUnassign] = useState(null);
  const [editMachines, setEditMachines] = useState();
  const [isAlert, setIsAlert] = useState(false);
  const [searchValue,setSearchValue] = useState();

  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = (data, edit) => {
    const param = { ...data };
    if (!edit) {
      param.method = Constants.MASTER.MACHINES.ADD;
    } else {
      param.method = Constants.MASTER.MACHINES.UPDATE;
    }
    param.edit = edit;
    dispatch(addMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_department.success_message"),
          2000
        );
        dispatch(fetchMasterList(Constants.MASTER.MACHINES)); // userSlice store
        setOpen(false);
      } else if (res?.payload?.errorcode === 1003) {
        setError(t("msg_master_list.msg_machines.duplicate_machine"));
        setIsError(true);
      } else {
        setError(t("msg_master_list.msg_machines.machine_add_error"));
        setIsError(true);
      }
    });
  };

  const handleDelete = () => {
    let param = {};
    param.machineList = selectedItem;
    param.method = Constants.MASTER.MACHINES.DELETE;

    dispatch(deleteMasterRecord(param)).then((res) => {
      console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_machines.delete_success_message"),
          2000
        );
        dispatch(fetchMasterList(Constants.MASTER.MACHINES));
        setSelectedItem([]);
        setConfirmModel(false);
      } else {
        setIsError(true);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_master_list.msg_machines.invalid_input"),
          4000
        );
      }
    });
  };

  const handleOpen = (data) => {
    if (data) {
      setEditMachines(data);
    }
    setOpen(true);
  };

  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.MACHINES)); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRowSelected = ({ selectedRows }) => {
    const selectMachines = selectedRows.map((item) => item._id);
    setSelectedItem([...selectMachines]);
  };

  const resetError = () => {
    setIsError(false);
    setError("");
  };

  const resetAlert = () => {
    setIsAlert(false);
  };

  const confirmBeforeDelete = (data, singleDelete = false) => {
    if (singleDelete) {
      setSelectedItem([data._id]);
      setConfirmModel(true);
    } else {
      if (selectedItem.length === 0) {
        setIsAlert(true);
        return
      } else {
        setConfirmModel(true);
      }
    }
  };

  const confirmBeforeUnassign = (machine) => {
    setMachineToUnassign(machine);
    setUnassignConfirmModel(true);
  };

  const handleUnassign = async () => {
    if (!machineToUnassign) return;

    const result = await ItemService.allCommonServices(
      {
        _id: machineToUnassign._id,
        jobcard: machineToUnassign.jobcard,
      },
      Constants.MASTER.MACHINES.UNASSIGN
    );

    if (result?.status === 200) {
      toastFunc(
        Constants.MASTER.TOAST.success,
        result.message || t("msg_master_list.msg_machines.unassign_success"),
        3000
      );
      setUnassignConfirmModel(false);
      setMachineToUnassign(null);
      dispatch(fetchMasterList(Constants.MASTER.MACHINES));
      return;
    }

    setUnassignConfirmModel(false);
    setMachineToUnassign(null);
    setError(
      result?.message || t("msg_master_list.msg_machines.unassign_error")
    );
    setIsError(true);
  };

  const handleSearch = () => {
    const param = { 
     ...Constants.MASTER.MACHINES,
      value: searchValue };
    if(searchValue){
      dispatch(searchMasterList(param)).then((res) => {
        if (res?.payload?.status === 200) {
          rowsData = res?.payload?.data;
        }
      });
    }
  };

  const onSearchChange = (e) => {
    if(e.target.value){
      setSearchValue(e.target.value)  
    }else{
      dispatch(fetchMasterList(Constants.MASTER.MACHINES))
      setSearchValue(e.target.value)
    }
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i
              className="bi bi-pencil-square iconTable"
              onClick={() => handleOpen(row)}
            ></i>
          </span>
          <span>
            <i
              className="bi bi-trash3 iconTable"
              onClick={() => confirmBeforeDelete(row, true)}
            ></i>
          </span>
          {row.canUnassignJobcard && (
            <button
              type="button"
              className="btn btn-sm btn-outline-warning ms-2"
              title={`${row.jobcard} is currently in ${row.jobcardToDeptCode}`}
              onClick={() => confirmBeforeUnassign(row)}
            >
              <i className="bi bi-link-45deg me-1"></i>
              {t("msg_master_list.msg_machines.unassign")}
            </button>
          )}
        </>
      ),
      width: "250px",
    },
    {
      name: t("msg_master_list.msg_machines.code"),
      selector: (row) => row.machineCode,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.machineCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_machines.machine_name"),
      selector: (row) => row.machineName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.machineName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_machines.related_departments"),
      selector: (row) => row.deptName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptCode}: {row.deptName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_machines.assigned_jobcard"),
      selector: (row) => row.jobcard || "",
      sortable: true,
      width: "210px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {row.jobcard || "-"}
          </p>
          {row.canUnassignJobcard && (
            <small className="text-danger">
              {t("msg_master_list.msg_machines.current_department")}: {row.jobcardToDeptCode}
            </small>
          )}
        </div>
      ),
    },
    {
      name: t("msg_common.status"),
      cell: (row) => (
        <>
          {row.status === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.status === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.status
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.createdDate,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row.createdDate)} </p>
        </div>
      ),
      center: true,
      width: "250px",
    },
  ];

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store
  let rowsData = masterList[Constants.MASTER.MACHINES.name]?.data;

  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {" "}
              {t("msg_master_list.msg_machines.name")}
            </h2>
            <p className="subText">
              {t("msg_master_list.msg_machines.details")}{" "}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="rightSide" >
        <Form>
                    <Form.Group>
                        <InputGroup>
                            <Form.Control
                                type="search"
                                placeholder={t("msg_common.search_placeholder")}
                                onChange={(e) => onSearchChange(e)}
                            />
                            <InputGroup.Text>
                            <i className="bi bi-search" onClick={handleSearch}></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                </Form>
        </Col>
        <hr />
      </Row>
      <MasterList
        columnsData={columnsData}
        rowsData={rowsData}
        paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
        pagination
        selectableRows
        handleClose
        handleOpen={handleOpen}
        handleDelete={confirmBeforeDelete}
        handleRowSelected={handleRowSelected}
      />
      {open && (
        <MachinesModal
          data={editMachines}
          show={open}
          onHide={handleClose}
          onSave={handleSave}
        ></MachinesModal>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_machines.delete_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_machines.delete_confirm_body")}
          onDelete={() => handleDelete()}
          onHide={() => setConfirmModel(false)}
          type={"delete"}
        ></ConfirmationModal>
      )}
      {unassignConfirmModel && machineToUnassign && (
        <ConfirmationModal
          show={unassignConfirmModel}
          heading={t("msg_master_list.msg_machines.unassign_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_machines.unassign_confirm_body", {
            jobcard: machineToUnassign.jobcard,
            machine: machineToUnassign.machineCode,
            department: machineToUnassign.jobcardToDeptCode,
          })}
          onOk={handleUnassign}
          onHide={() => {
            setUnassignConfirmModel(false);
            setMachineToUnassign(null);
          }}
          type="common"
        />
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_master_list.msg_machines.machine_error_heading")}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}

      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_common.selectRecord")}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </main>
  );
};

export default Machines;
